import React from 'react';

import DataConnector from 'connect/DataConnector';
import {Entry} from 'notebook/entries/backbone/filestate/Entry';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import * as Headers from 'ui-library/Headers';

import {getRelevantStateObjects, getResultStatusTabTables} from './getResultStatusTabTables';
import {ResultStatusTabTableShape} from './ResultStatusTabConstants';
import ResultStatusTabTable from './ResultStatusTabTable';

interface ResultStatusTabProps {
  entryFile: Entry;
}

interface ResultStatusTabEnhancedProps {
  tables: Array<ResultStatusTabTableShape>;
}

class ResultStatusTabConnector extends DataConnector<ResultStatusTabProps, ResultStatusTabEnhancedProps> {
  enhanceProps(): ResultStatusTabEnhancedProps {
    return {
      tables: getResultStatusTabTables(this.props.entryFile, getRelevantStateObjects(this.reduxState())),
    };
  }
}

function ResultStatusTab(props: ResultStatusTabProps & ResultStatusTabEnhancedProps): JSX.Element {
  return (
    <div className="react-tab-container" {...getTestProps({component: 'ResultStatusTab', element: 'root'})}>
      <Headers.Header1>{MODEL_NAMES.Result} Status</Headers.Header1>
      {props.tables.map((table, index) => (
        <ResultStatusTabTable table={table} key={index} />
      ))}
    </div>
  );
}

export default ResultStatusTabConnector.connect(ResultStatusTab);
